import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { Container } from '@plone/components';
import SeminareExpanded, {
  formatDate,
  type ListingItem,
} from '../../Blocks/Listing/SeminareExpanded';
import React from 'react';
import { useSelector } from 'react-redux';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';

type SeminarViewProps = {
  content: ListingItem;
};

const separatorContent = {
  blocks: {
    'seminar-separator': {
      '@type': 'separator',
      styles: {
        align: 'full',
      },
    },
  },
  blocks_layout: {
    items: ['seminar-separator'],
  },
};

const SeminarView = ({ content }: SeminarViewProps) => {
  const lang = useSelector(
    (state: { intl: { locale: string } }) => state.intl.locale,
  );
  const locale = toBackendLang(lang);
  const startDate = formatDate(content.start_date, locale);
  const endDate = formatDate(content.end_date, locale);
  const dateRange =
    content.technical_type === 'muenchenprogramm'
      ? startDate || endDate
      : [startDate, endDate].filter(Boolean).join(' – ');

  return (
    <Container width="default" className="seminare-view">
      <RenderBlocks content={separatorContent} isContainer />
      {dateRange && <p className="seminare-kicker">Termin {dateRange}</p>}
      {(content.thema || content.title) && (
        <h1 className="seminare-view-heading">
          {content.thema || content.title}
        </h1>
      )}
      <p class="seminare-teaser">
        {content.thema_zusatz && (
          <span className="seminare-topic-addition">
            {content.thema_zusatz}
          </span>
        )}
      </p>
      <div className="seminare-view">
        <div className="is-open">
          <SeminareExpanded
            isOpen
            item={content}
            itemKey={content['@id'] || content.id || 'seminar'}
          />
        </div>
      </div>
      <RenderBlocks content={separatorContent} isContainer />
    </Container>
  );
};

export default SeminarView;
